@import '../../../../../../../constants/spacing.module.less';

.edit-address-modal-body {
  min-height: 570px;
  padding: @space-16 @space-16 @space-32;
  gap: @space-32;
}

.column {
  flex: 1;
  gap: @space-8;
}

.paste-address {
  display: flex;
  flex-direction: column;
  gap: @space-4;
  padding: @space-12 @space-12 @space-16;

  background-color: var(--order-details-canvas--nav--text-color);
  border-radius: 8px;
}

.paste-address-header {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  display: flex;
  gap: @space-8;
  align-items: center;

  > svg {
    fill: var(--default--icon--fill-color--11);
    height: 16px;
  }
}

.paste-address-description {
  font-size: 12px;
  line-height: 18px;
}

.paste-address-country-label {
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.address-options-section {
  display: flex;
  flex-direction: column;
  gap: @space-8;
}

.address-options-subtitle {
  font-size: 12px;
  line-height: 16px;
}

.edit-address-footer {
  height: fit-content;
  .edit-address-footer-buttons {
    display: flex;
    justify-content: space-between;
    padding: @space-16 @space-0;
    .edit-address-footer-right-side {
      display: flex;
      align-items: flex-end;
      gap: @space-8;
    }
  }
}

.validate-address-section {
  gap: @space-16;
  align-items: center;
}

.validation-icon {
  height: 18px;
  width: 18px;
  margin-right: @space-4;
}

.validation-loading-icon {
  height: 36px;
  width: 36px;
}

.validation-text {
  color: var(--grey-600);
  display: flex;
  align-items: center;
}

.subtitle-wrapper {
  margin: @space-16 @space-16 @space-16;
  justify-content: space-between;
  align-items: center;
  padding-bottom: @space-16;
  border-bottom: solid 1px var(--grey-300);
}

.label-lock-icon {
  margin-left: @space-4;
  height: 10px;
  color: var(--grey-600);
}
